import { render, staticRenderFns } from "./OrgTables.vue?vue&type=template&id=74aec3bd&scoped=true&"
import script from "./OrgTables.vue?vue&type=script&lang=js&"
export * from "./OrgTables.vue?vue&type=script&lang=js&"
import style0 from "./OrgTables.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrgTables.vue?vue&type=style&index=1&id=74aec3bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aec3bd",
  null
  
)

export default component.exports